import { CommonModule } from "@angular/common";
import { Component, inject, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { finalize, take } from "rxjs/operators";
import { AuthService } from "../../services/auth.service";
import {
  RoleModel,
  UserManagementModel,
} from "src/app/services/models/user-management/user-management.model";

@Component({
  selector: "app-select-role",
  imports: [CommonModule],
  templateUrl: "./select-role.component.html",
  styleUrls: ["./select-role.component.scss"],
})
export class SelectRoleComponent implements OnInit {
  user?: UserManagementModel;
  availableRoles: RoleModel[] = [];
  selectedRoleId: number | null = null;
  isSubmitting = false;

  private authService = inject(AuthService);
  private router = inject(Router);

  get fullName(): string {
    if (this.user == null) {
      return "-";
    }

    if (typeof this.user.full_name === "string" && this.user.full_name.length > 0) {
      return this.user.full_name;
    }

    return "-";
  }

  get canContinue(): boolean {
    return this.selectedRoleId !== null && !this.isSubmitting;
  }

  ngOnInit(): void {
    const auth = this.authService.currentUserValue;

    if (auth?.user == null) {
      void this.router.navigate(["/auth/login"]);
      return;
    }

    this.user = auth.user;
    this.availableRoles = auth.user.roles;
    const selectedRole = this.authService.getSelectedRole();

    this.selectedRoleId =
      selectedRole && this.availableRoles.some((role) => role.id === selectedRole.id)
        ? selectedRole.id
        : null;
  }

  getSelectedLabel(role: RoleModel): string {
    return role.label;
  }
  continue(): void {
    if (!this.canContinue || this.selectedRoleId == null) {
      return;
    }

    const selectedRoleId = this.selectedRoleId;
    const selectedRole = this.availableRoles.find((role) => role.id === selectedRoleId);
    if (!selectedRole) {
      return;
    }

    this.isSubmitting = true;
    this.authService.verifyRole(selectedRoleId).pipe(
      take(1),
      finalize(() => {
        this.isSubmitting = false;
      }),
    ).subscribe((session) => {
      if (!session?.active_role) {
        return;
      }

      void this.authService.navigateAfterAuthentication(session);
    });
  }

  isSelected(roleId: number): boolean {
    return this.selectedRoleId === roleId;
  }

  toggleRole(role: RoleModel): void {
    if (this.isSubmitting) {
      return;
    }

    this.selectedRoleId = role.id;
    this.continue();
  }

  logout(): void {
    this.authService.logout();
  }
}
